import { DataMapper } from 'modules/core/domain/interfaces/data-mapper';

import { AvailableTournamentDto } from '../dtos/available-tournament.dto';
import { AuthAvailableTournament } from '../interfaces/auth-available-tournament';

export class AvailableTournamentDataMapper implements DataMapper<AuthAvailableTournament, AvailableTournamentDto> {
  public decode(encoded: AvailableTournamentDto): AuthAvailableTournament {
    return {
      id: encoded.id,
      name: encoded.name,
      sportType: encoded.sport_type,
    };
  }

  public encode(decoded: AuthAvailableTournament): AvailableTournamentDto {
    return {
      id: decoded.id,
      name: decoded.name,
      sport_type: decoded.sportType,
    };
  }
}
